import { useState } from "react";
import InfoLayout from "../components/InfoLayout";
import usePageMeta from "../hooks/usePageMeta";
import { cleanRegistration } from "../utils/registration";

export default function ContactPage({ brand }) {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  usePageMeta({
    title: `Contact ${brand.name}`,
    description: `Contact ${brand.name} about a vehicle report, payment, registration, or general question.`,
  });

  const submit = async (event) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          brand: brand.key,
          name: formData.get("name"),
          email: formData.get("email"),
          subject: formData.get("subject"),
          registration: cleanRegistration(formData.get("registration")) || null,
          message: formData.get("message"),
        }),
      });

      if (response.ok) {
        setStatus("Message sent. We will get back to you as soon as possible.");
        formEl.reset();
      } else {
        const data = await response.json().catch(() => ({}));
        setStatus(data.error || "Failed to send message. Please try again.");
      }
    } catch {
      setStatus("Failed to send. Please email us directly at " + brand.email);
    } finally {
      setLoading(false);
    }
  };

  return (
    <InfoLayout brand={brand} eyebrow="Contact" title="How can we help?" intro="Ask about a report, payment, vehicle registration, or anything else related to the service.">
      <section className="content">
        <div className="wrap contact-grid">
          <div className="contact-form">
            <h2>Send a message</h2>
            <form onSubmit={submit}>
              <div className="field"><label htmlFor="subject">SUBJECT</label><select id="subject" name="subject"><option>Report not received</option><option>Payment question</option><option>Registration information</option><option>Product question</option><option>Error report</option><option>General enquiry</option></select></div>
              <div className="field"><label htmlFor="name">NAME</label><input id="name" name="name" required autoComplete="name" /></div>
              <div className="field"><label htmlFor="email">EMAIL</label><input id="email" name="email" type="email" required autoComplete="email" /></div>
              <div className="field"><label htmlFor="registration">REGISTRATION, OPTIONAL</label><input id="registration" name="registration" maxLength="8" autoComplete="off" onInput={(event) => { event.currentTarget.value = cleanRegistration(event.currentTarget.value); }} /></div>
              <div className="field"><label htmlFor="message">MESSAGE</label><textarea id="message" name="message" required /></div>
              <button className="submit" type="submit" disabled={loading}>{loading ? "Sending..." : "Send message"}</button>
              <div className="form-status" aria-live="polite">{status}</div>
            </form>
          </div>
          <aside className="contact-card">
            <h2>Contact details</h2>
            <p>We aim to acknowledge complaints within five working days and answer support enquiries as soon as reasonably possible.</p>
            <div className="detail"><small>Phone</small><strong><a href={`tel:${brand.phone}`}>{brand.phone}</a></strong></div>
            <div className="detail"><small>Email</small><strong><a href={`mailto:${brand.email}`}>{brand.email}</a></strong></div>
            <div className="detail"><small>Brand</small><strong>{brand.name}</strong></div>
          </aside>
        </div>
      </section>
    </InfoLayout>
  );
}
